// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1032":"94505f3c","2542":"8fcd82a4","2932":"eda83d78","4850":"4b96087f"}[chunkId] + ".chunk.css";
};